import axios from 'axios';
export const masterForm = {
    props: [
        'form_key',
        'category_id',
        'subject',
        'session_message',
        'queryParams',
    ],
    data() {
        return {
            form: {},
            postedSuccessfully: false,
            session_message: null,
            submitting: false,
            fileUploadFields: ['attachments'], // ['attachments']
        };
    },
    mounted() {
        this.form.subject = this.subject;
    },
    methods: {
        getPostableFields(formData) {
            const data = {};
            const baseFields = ['control', 'email', 'message', 'subject', 'name', 'recaptcha_response'];
            const additionalFields = {};
            let category_id = 0;
            Object.keys(formData).forEach((fld) => {
                if (fld === 'category_id') {
                    category_id = formData[fld];
                    return;
                }
                if (baseFields.includes(fld)) {
                    if (fld === 'recaptcha_response') {
                        data['recaptcha_response'] = formData[fld];
                    }
                    else {
                        data[fld] = formData[fld];
                    }
                }
                else {
                    additionalFields[fld] = formData[fld];
                }
            });
            data['fields'] = additionalFields;
            data['category_id'] = this.category_id;
            return data;
        },
        prepareRequestWithoutFileUploads(formData) {
            const request = {};
            const data = this.getPostableFields(formData);
            const formKey = formData['category_id'];
            Object.keys(data).forEach((fld) => {
                if (fld !== 'recaptcha_response') {
                    request[fld] = this.createJson(formKey, data[fld]);
                }
                else {
                    request[fld] = data[fld];
                }
            });
            request['category_id'] = this.createJson(formKey, formKey);
            return request;
        },
        prepareRequestWithFileUploads(request) {
            const formData = new FormData();
            const category_id = Object.keys(request.category_id)[0];
            formData.append('category_id', category_id);
            const { fields, ...otherFields } = request;
            formData.append('form_data', JSON.stringify(otherFields)); // Append form_data without attachments
            // Process fields[category_id] separately
            if (fields && fields[category_id]) {
                // Iterate over properties of fields[category_id] and append them dynamically
                Object.entries(fields[category_id]).forEach(([key, value]) => {
                    if (key !== 'attachments') {
                        formData.append(`fields[${category_id}][${key}]`, String(value));
                    }
                });
                // Process attachments
                if (fields[category_id].attachments) {
                    const attachments = fields[category_id].attachments;
                    // Check if attachments is an object (from FilePond)
                    if (typeof attachments === 'object' && attachments.length) {
                        // Append each attachment individually
                        attachments.forEach((file, index) => {
                            formData.append(`fields[${category_id}][attachments][${index}]`, file);
                        });
                    }
                    else {
                        // Append single attachment
                        formData.append(`fields[${category_id}][attachments]`, attachments);
                    }
                }
            }
            return formData;
        },
        prepareData(formData, hasFileUploads) {
            const request = this.prepareRequestWithoutFileUploads(formData);
            if (hasFileUploads) {
                return this.prepareRequestWithFileUploads(request);
            }
            const formKey = formData['category_id'];
            request['category_id'][formKey] = formData['category_id'];
            return request;
        },
        initialiseFormData() {
            Object.keys(this.form).forEach((fld) => {
                this.form[fld] = null;
            });
        },
        submitForm(formData, callback, hasFileUploads) {
            const formKey = formData['category_id'];
            const headers = hasFileUploads ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
            axios
                .post('/forms/submissions/' + formKey, this.prepareData(formData, hasFileUploads), headers)
                .then((response) => {
                const message = response.data;
                callback(message);
            })
                .catch((e) => {
                console.log(e);
            });
        },
        createJson(key, name) {
            const json = {};
            json[key] = name;
            return json;
        },
    },
};
